// extracted by mini-css-extract-plugin
export default {"container":"BlogDetail_container__LaZtr","wrapper":"BlogDetail_wrapper__7Iyx1"};